import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { rem } from "./auth-service-tools172.js";
import "react";
import { getSize, getFontSize, getRadius } from "./auth-service-tools185.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { extractStyleProps } from "./auth-service-tools237.js";
import { Box } from "./auth-service-tools244.js";
import { polymorphicFactory } from "./auth-service-tools249.js";
import { InputDescription } from "./auth-service-tools300.js";
import { InputError } from "./auth-service-tools301.js";
import { InputLabel } from "./auth-service-tools302.js";
import { InputPlaceholder } from "./auth-service-tools303.js";
import { useInputWrapperContext } from "./auth-service-tools304.js";
import { InputWrapper } from "./auth-service-tools305.js";
import classes from "./auth-service-tools306.js";
const defaultProps = {
  variant: "default",
  leftSectionPointerEvents: "none",
  rightSectionPointerEvents: "none",
  withAria: true,
  withErrorStyles: true
};
const varsResolver = createVarsResolver((_, props, ctx) => ({
  wrapper: {
    "--input-margin-top": ctx.offsetTop ? "calc(var(--mantine-spacing-xs) / 2)" : void 0,
    "--input-margin-bottom": ctx.offsetBottom ? "calc(var(--mantine-spacing-xs) / 2)" : void 0,
    "--input-height": getSize(props.size, "input-height"),
    "--input-fz": getFontSize(props.size),
    "--input-radius": props.radius === void 0 ? void 0 : getRadius(props.radius),
    "--input-left-section-width": props.leftSectionWidth !== void 0 ? rem(props.leftSectionWidth) : void 0,
    "--input-right-section-width": props.rightSectionWidth !== void 0 ? rem(props.rightSectionWidth) : void 0,
    "--input-padding-y": props.multiline ? getSize(props.size, "input-padding-y") : void 0,
    "--input-left-section-pointer-events": props.leftSectionPointerEvents,
    "--input-right-section-pointer-events": props.rightSectionPointerEvents
  }
}));
const Input = polymorphicFactory((_props, ref) => {
  const props = useProps("Input", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    required,
    __staticSelector,
    __stylesApiProps,
    size,
    wrapperProps,
    error,
    disabled,
    leftSection,
    leftSectionProps,
    leftSectionWidth,
    rightSection,
    rightSectionProps,
    rightSectionWidth,
    rightSectionPointerEvents,
    leftSectionPointerEvents,
    variant,
    vars,
    pointer,
    multiline,
    radius,
    id,
    withAria,
    withErrorStyles,
    mod,
    inputSize,
    ...others
  } = props;
  const {
    styleProps,
    rest
  } = extractStyleProps(others);
  const ctx = useInputWrapperContext();
  const stylesCtx = {
    offsetBottom: ctx == null ? void 0 : ctx.offsetBottom,
    offsetTop: ctx == null ? void 0 : ctx.offsetTop
  };
  const getStyles = useStyles({
    name: ["Input", __staticSelector],
    props: __stylesApiProps || props,
    classes,
    className,
    style,
    classNames,
    styles,
    unstyled,
    stylesCtx,
    rootSelector: "wrapper",
    vars,
    varsResolver
  });
  const ariaAttributes = withAria ? {
    required,
    disabled,
    "aria-invalid": !!error,
    "aria-describedby": ctx == null ? void 0 : ctx.describedBy,
    id: (ctx == null ? void 0 : ctx.inputId) || id
  } : {};
  return /* @__PURE__ */jsxRuntimeExports.jsxs(Box, { ...getStyles("wrapper"),
    ...styleProps,
    ...wrapperProps,
    mod: [{
      error: !!error && withErrorStyles,
      pointer,
      disabled,
      multiline,
      "data-with-right-section": !!rightSection,
      "data-with-left-section": !!leftSection
    }, mod],
    variant,
    size,
    children: [leftSection && /* @__PURE__ */jsxRuntimeExports.jsx("div", { ...leftSectionProps,
      "data-position": "left",
      ...getStyles("section", {
        className: leftSectionProps == null ? void 0 : leftSectionProps.className,
        style: leftSectionProps == null ? void 0 : leftSectionProps.style
      }),
      children: leftSection
    }), /* @__PURE__ */jsxRuntimeExports.jsx(Box, {
      component: "input",
      ...rest,
      ...ariaAttributes,
      ref,
      required,
      mod: {
        disabled,
        error: !!error && withErrorStyles
      },
      variant,
      __size: inputSize,
      ...getStyles("input")
    }), rightSection && /* @__PURE__ */jsxRuntimeExports.jsx("div", { ...rightSectionProps,
      "data-position": "right",
      ...getStyles("section", {
        className: rightSectionProps == null ? void 0 : rightSectionProps.className,
        style: rightSectionProps == null ? void 0 : rightSectionProps.style
      }),
      children: rightSection
    })]
  });
});
Input.classes = classes;
Input.Wrapper = InputWrapper;
Input.Label = InputLabel;
Input.Error = InputError;
Input.Description = InputDescription;
Input.Placeholder = InputPlaceholder;
Input.displayName = "@mantine/core/Input";
export { Input };